import React, { HTMLProps } from 'react';
import { IconElements } from '../../config/icons';

export const OverlayHeader: React.FC<
    { title?: string; selectionYears?: number[]; onClose?: () => void } & HTMLProps<HTMLDivElement>
> = ({ title, selectionYears, onClose, className, ...rest }) => {
    return (
        <div className="flex flex-row justify-between mb-8">
            <div className="text-3xl font-medium">{title}</div>
            {onClose && (
                <div>
                    <button
                        className="ml-8 text-2xl flex items-center focus:outline-none cursor-pointer"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        <IconElements.Cross className="text-bnd-green w-6 h-6 sm:h-8 sm:w-8 hover:text-bnd-green-hover transition" />
                    </button>
                </div>
            )}
        </div>
    );
};
